<!-- Cropping Modal -->
<ion-modal [isOpen]="isOpen" (didDismiss)="onCancel()" [backdropDismiss]="false">
    <ng-template>
        <div class="cropping-modal">
            <div sxPadding="medium" sxRow sxDistribution="spaceBetween" sxAlign="center">
                <button sxCircle="46px" sxCenterize="row" sxColor="white" sxBackground="black" (click)="onCancel()">
                    <ion-icon name="arrow-back-outline" sxTextSize="32px"></ion-icon>
                </button>
                <button sxCircle="46px" sxCenterize="row" sxBackground="black" sxTextSize="48px" (click)="onConfirm()">
                    <ion-icon sxColor="white" name="checkmark-circle"></ion-icon>
                </button>
            </div>
            <div class="cropper-container-wrapper">
                <!-- Cropping Mode -->
                <div *ngIf="!showPreview" class="cropping-mode">
                    <canvas #canvas [class]="getCanvasClass()" (mousedown)="onMouseDown($event)"
                        (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp()" (mouseleave)="onMouseUp()"
                        (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)"
                        (touchend)="onTouchEnd($event)" class="cropper-canvas">
                    </canvas>

                    <div class="rotation-controls">
                        <p>Rotate</p>
                        <button class="rotation-btn" (click)="rotateLeft()" title="Rotate Left">
                            <ion-icon class="flip-icon" name="refresh-outline"></ion-icon>
                        </button>

                        <button class="rotation-btn" (click)="rotateRight()" title="Rotate Right">
                            <ion-icon name="refresh-outline"></ion-icon>
                        </button>
                    </div>
                </div>

                <!-- Preview Mode -->
                <div *ngIf="showPreview" class="preview-mode">
                    <div class="preview-image-container">
                        <img [src]="previewImageUrl" alt="Cropped preview" class="preview-image" />
                    </div>
                    <div sxRow sxDistribution="spaceBetween" sxAlign="center" sxPadding="medium" sxGap="10px">
                        <super-button type="outline" borderColor="light" color="light" (click)="rejectPreview()"
                            iconStart="arrow-back-outline">
                            Edit
                        </super-button>
                        <super-button type="light" (click)="acceptPreview()" iconEnd="arrow-forward-outline">
                            Confirm
                        </super-button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</ion-modal>